import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VrcTextareaComponent } from './vrc-textarea.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { VrCommonModule } from '../../vr-common.module';

const exports = [VrcTextareaComponent];

@NgModule({
  declarations: [...exports],
  exports,
  imports: [
    CommonModule,
    VrCommonModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class VrcTextareaModule { }
